import apiClient from './apiClient';

/**
 * Get staging count for a specific section
 * @param {string} section - Section identifier (greige-storage, processing, inhouse, dispatch)
 */
export const getStagingCount = async (section) => {
  const response = await apiClient.get(`/staging/${section}/count`);
  return response.data;
};

/**
 * Get staging counts for all sections at once
 */
export const getAllStagingCounts = async () => {
  const response = await apiClient.get('/staging/all/counts');
  return response.data;
};
